import styled from 'styled-components';
import { getColor, getSize, responsive } from '~/helpers/style';

export const Container = styled.div`
  padding: 24px;
  background-color: ${getColor('white')};
  border: solid 1px ${getColor('border')};
  border-radius: ${getSize(1.2)};
  margin: 20px 0;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 24px;
`;

export const DesktopWrapper = styled.div`
  display: none;

  @media (min-width: 1024px) {
    align-item: center;
    display: block;
  }
`;

export const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const Content = styled.div`
  align-item: center;
  display: flex;
  flex-direction: column;
  max-height: 300px;

  @media (min-width: 1024px) {
    align-item: center;
    flex-direction: row;
    gap: 24px;
  }
`;

export const VideoBox = styled.div`
  flex: 1;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f5f5f5;
  height: 100%;

  video,
  img {
    width: 100%;
    display: block;
    object-fit: cover;
  }

  @media (min-width: 1024px) {
    height: 300px;
    margin: auto;
    video,
    img {
      height: 300px;
    }
  }
`;

export const VideoPlayer = styled.video``;


export const Thumbnail = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 8px;
  background: ${getColor("primary")};
  color: ${getColor("white")};
  height: 100%;
  padding: 0 20px;
  min-height: 280px;
  
  h1{
    font-weight: 600;
    font-size: 37px;
    line-height: 42px;
    text-align: center;
    text-transform: capitalize;
  }

  ${responsive("desktop")} {
    padding: 0 5px;

    h1{
      font-size: 28px;
    }
  }
`;

export const PlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 50%;
  padding: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  border: none;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
    fill: #2563eb;
  }
`;

export const TutorialList = styled.div`
  flex: 1;
  margin-top: 24px;

  @media (min-width: 1024px) {
    margin-top: 0;
    overflow-x: auto;
  }
`;

export const TutorialItem = styled.div<{ active?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  color: ${({ active }) => (active ? '#2563eb' : '#111827')};
  font-weight: ${({ active }) => (active ? '600' : '400')};

  &:hover {
    background-color: #f9fafb;
  }
`;

export const TutorialText = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  img {
    width: 20px;
    height: 20px;
  }
`;

export const TutorialDuration = styled.span`
  font-size: 14px;
`;

export const MobileNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  width: 100%;
`;

export const Arrow = styled.button<{ disabled?: boolean }>`
  background: none;
  border: none;
  font-size: 14px;
  white-space: nowrap;
  display: flex;
  color: ${({ disabled }) => (disabled ? '#ccc' : '#2563eb')};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;

export const VideoTitle = styled.div`
  flex: 1;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
  padding: 0 12px;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background: rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;